<template>
  <div class="core-values-component">
    <div class="core-values">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="core-values-text">
              <h3>
                <strong>What we value as <br> a company matters.</strong>
              </h3>

              <p class="spacing">
                We care for our community - our team, customers and suppliers.
                We want to make them happy even in the littlest ways, putting
                there concerns ahead of our own. We love to make people feel
                awesome about themselves.
              </p>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="core-values-details" :class="media.isDesktop ? 'spacing-6' : ''">
              <div class="row">
                <div class="col-12 col-lg-6" :class="!media.isDesktop ? 'text-center spacing' : ''">
                  <div class="excellence" :class="!media.isDesktop ? 'mx-auto' : ''"></div>
                  <h3 class="mt-3 font-weight-bold">Excellence</h3>
                  <p>Whatever is worth doing, is doing worth well.</p>
                </div>
                <div class="col-12 col-lg-6" :class="!media.isDesktop ? 'text-center spacing' : ''">
                  <div class="hard-work" :class="!media.isDesktop ? 'mx-auto' : ''"></div>
                  <h3 class="mt-3 font-weight-bold">Hard Work</h3>
                  <p>
                    We believe in the value of hard work because nothing big
                    comes easy. We are willing to work hard at making our dreams
                    come true.
                  </p>
                </div>
                <div class="col-12 col-lg-6 spacing" :class="!media.isDesktop ? 'text-center' : ''">
                  <div class="fun" :class="!media.isDesktop ? 'mx-auto' : ''"></div>
                  <h3 class="mt-3 font-weight-bold">Fun</h3>
                  <p>
                    We believe that having fun is important in having a secure,
                    strong and passionate environment. We enjoy what we choose
                    to do wherever we may be.
                  </p>
                </div>
                <div class="col-12 col-lg-6 spacing" :class="!media.isDesktop ? 'text-center' : ''">
                  <div class="positivity" :class="!media.isDesktop ? 'mx-auto' : ''"></div>
                  <h3 class="mt-3 font-weight-bold">Positivity</h3>
                  <p>
                    Whatever happens, we choose to look at the bright side -
                    focusing our efforts on learning and progress.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoreValues",
  computed: {
    media() {
      return {
        "isDesktop": this.$screen.lg
      };
    }
  }
};
</script>

<style lang="sass" scoped>
.core-values
  background-color: $dutche-primary-yellow
  color: $dutche-primary-violet
  padding-bottom: 5rem

  h3
    font-size: 1em

  .core-values-text
    margin: 6rem 1rem 1rem 1rem

  .core-values-details
    margin: 1rem

  .spacing
    margin-top: 2rem

  .spacing-6
    margin-top: 6rem

  .excellence
    background-image: url('../../assets/images/about/excellence.svg')
    background-size: 50px 50px
    width: 50px
    height: 50px
  .hard-work
    background-image: url('../../assets/images/about/hard-work.svg')
    background-size: 50px 50px
    width: 50px
    height: 50px
  .fun
    background-image: url('../../assets/images/about/fun.svg')
    background-size: 50px 50px
    width: 50px
    height: 50px
  .positivity
    background-image: url('../../assets/images/about/positivity.svg')
    background-size: 50px 50px
    width: 50px
    height: 50px
</style>
